import { render, staticRenderFns } from "./DeductionDropdown.vue?vue&type=template&id=0550d72c&"
import script from "./DeductionDropdown.vue?vue&type=script&lang=js&"
export * from "./DeductionDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports